/* Margot & Rose
   1. Rewrites Dawn's "Sale" badge to the discount percentage.
   2. Relabels the hover quick-add button as "Quick view".
   3. Swaps Dawn's header icons for the reference line-art set.
      Dawn renders these inline in sections/header.liquid rather than through
      snippets/icon-*.liquid, so overriding the snippets alone does not reach
      them -- they are replaced here instead of forking Dawn's header section.
*/
(function () {
  var QUICK_LABELS = ['choose options', 'add to cart', '+ add', 'add'];

  var BAG = '<path d="M11.38 17.86h41.25v36.75H11.38z"/><path d="M22.25 18c0-7.11 4.35-9 9.75-9s9.75 1.9 9.75 9"/>';

  var ICONS = {
    'icon-hamburger': '<path d="M7 15h51M7 32h43M7 49h51"/>',
    'icon-search': '<path d="M47.16 28.58A18.58 18.58 0 1 1 28.58 10a18.58 18.58 0 0 1 18.58 18.58ZM54 54 41.94 42"/>',
    'icon-close': '<path d="m19 17.61 27.12 27.13m0-27.12L19 44.74"/>',
    'icon-cart': BAG,
    'icon-cart-empty': BAG
  };

  function num(el) {
    if (!el) return NaN;
    var raw = (el.textContent || '').replace(/[^0-9.,]/g, '').replace(/,/g, '');
    return parseFloat(raw);
  }

  function badges(scope) {
    var cards = scope.querySelectorAll('.card-wrapper, .card');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var badge = card.querySelector('.card__badge span, .card__badge .badge');
      if (!badge || badge.getAttribute('data-mr-pct')) continue;

      var regular = card.querySelector('.price__sale .price-item--regular');
      var sale = card.querySelector('.price__sale .price-item--sale');
      if (!regular || !sale) continue;

      var r = num(regular);
      var s = num(sale);
      if (!isFinite(r) || !isFinite(s) || r <= 0 || s >= r) continue;

      badge.textContent = '-' + Math.round((1 - s / r) * 100) + '%';
      badge.setAttribute('data-mr-pct', '1');
    }
  }

  function relabel(scope) {
    var btns = scope.querySelectorAll('.quick-add button, .quick-add .button');
    for (var i = 0; i < btns.length; i++) {
      var btn = btns[i];
      if (btn.getAttribute('data-mr-label')) continue;

      // Only swap the visible label; leave nested spinner / a11y nodes alone.
      var nodes = btn.childNodes;
      for (var j = 0; j < nodes.length; j++) {
        var node = nodes[j];
        if (node.nodeType !== 3) continue;
        var text = (node.nodeValue || '').trim().toLowerCase();
        if (QUICK_LABELS.indexOf(text) === -1) continue;
        node.nodeValue = 'Quick view';
        btn.setAttribute('data-mr-label', '1');
        break;
      }
    }
  }

  function icons(scope) {
    var svgs = scope.querySelectorAll('svg.icon');
    for (var i = 0; i < svgs.length; i++) {
      var svg = svgs[i];
      if (svg.getAttribute('data-mr-icon')) continue;

      var cls = svg.getAttribute('class') || '';
      var key = null;
      for (var name in ICONS) {
        if (cls.indexOf(name) > -1) { key = name; break; }
      }
      if (!key) continue;

      svg.setAttribute('viewBox', '0 0 64 64');
      svg.setAttribute('fill', 'none');
      svg.setAttribute('stroke', 'currentColor');
      svg.setAttribute('stroke-width', '3');
      svg.setAttribute('stroke-linecap', 'round');
      svg.setAttribute('stroke-linejoin', 'round');
      svg.innerHTML = ICONS[key];
      svg.setAttribute('data-mr-icon', '1');
    }
  }

  function paint() {
    badges(document);
    relabel(document);
    icons(document);
  }

  function boot() {
    paint();
    if (!window.MutationObserver) return;
    var pending = null;
    new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(paint, 60);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
